export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/asciiDecoder.worker.6ba5671f.worker.js");
}
